export const UNITED_KINGDOM = {
  NAME: 'United Kingdom',
  LABEL: 'United Kingdom of Great Britain and Northern Ireland',
  COUNTRY_CODE: 'GB',
};
